<template>
  <v-card>
    <v-toolbar color="indigo" style="position: sticky; top: 0px; z-index: 1">
      <v-toolbar-title class="white--text" dense>
        Registrazione Tempi di Fermo
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickSalva" large v-bind="attrs" v-on="on">
            <v-icon color="success" style="font-size: 40px">
              mdi-floppy
            </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di chiusura -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" large v-bind="attrs" v-on="on">
            <v-icon color="error" style="font-size: 40px"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5">
      <v-row align="center" style="text-align: left">
        <v-col cols="4">
          <span style="color: #3399ff; font-size: 20px; margin-right: 10px"
            >Utente:</span
          >
          <span style="font-size: 20px">{{ nome_utente }}</span>
        </v-col>
        <v-col cols="4">
          <span style="color: #3399ff; font-size: 20px; margin-right: 10px">
            Commessa:
          </span>
          <span style="font-size: 20px">{{ work_order_sel.cod_commessa }}</span>
        </v-col>
        <v-col cols="4"></v-col>
      </v-row>
      <v-row align="center" style="text-align: left">
        <v-col cols="4">
          <span style="color: #3399ff; font-size: 20px; margin-right: 10px"
            >Work Order:</span
          >
          <span style="font-size: 20px">{{ work_order_sel.cod_fase }}</span>
        </v-col>
        <v-col cols="4">
          <span style="color: #3399ff; font-size: 20px; margin-right: 10px"
            >Macchina:</span
          >
          <span style="font-size: 20px">{{ work_order_sel.cod_macchina }}</span>
        </v-col>
        <v-col cols="4">
          <span style="color: #3399ff; font-size: 20px; margin-right: 10px"
            >Data:</span
          >
          <span style="font-size: 20px">{{ work_order_sel.ora_stop }}</span>
        </v-col>
      </v-row>

      <!-- Riga della tabella dinamica dei dati di produzione -->
      <v-row align="center" justify="center">
        <v-col cols="12" align="center">
          <!-- Tabella dei dati automatici (se ci sono dati) -->
          <v-data-table
            class="elevation-2"
            :headers="tabella_custom.colonne"
            hide-default-footer
            :items="result_query"
            v-if="tabella_custom.id_query > 0"
          >
            <!-- Spazio del titolo della tabella -->
            <template v-slot:top>
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  {{ tabella_custom.titolo }}
                </v-toolbar-title>
              </v-toolbar>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td
                  v-for="(colonna, index) in tabella_custom.colonne"
                  :style="calcoloFormato(item, colonna)"
                  :key="index"
                >
                  {{ item[colonna.value] }}
                </td>
              </tr>
            </template>
          </v-data-table>

          <!-- Card alternativa alla tabella per dire che non ci sono dati -->
          <v-card outlined width="500px" v-else>
            <v-card-text>
              <span style="font-size: 15px">
                <b>Nessun dato automatico di produzione disponibile.</b>
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-divider class="my-5"></v-divider>

      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-data-table :headers="headers_causali" :items="causali">
            <template v-slot:top>
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  Totale Tempi Inseriti: {{ totale_tempi }}
                </v-toolbar-title>
              </v-toolbar>
            </template>
            <template v-slot:[`item.minuti`]="{ item }">
              <v-text-field
                background-color="#ffffff"
                @input="calcolaTotaleTempi()"
                class="mr-5"
                dense
                hide-details
                outlined
                style="
                  border-radius: 0px;
                  display: inline-block;
                  font-size: 20px;
                  line-height: 25px;
                  max-width: 100px;
                "
                type="number"
                :min="0"
                v-model.number="item.minuti"
              >
              </v-text-field>
            </template>
            <template v-slot:[`item.split`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="apriDialogDistribuzioneTempi(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary"> mdi-table-split-cell </v-icon>
                  </v-btn>
                </template>
                <span>Distribuisci minuti</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- Dialog distribuzione tempi -->
    <v-dialog
      persistent
      class="mt-5"
      max-width="700px"
      v-model="dialog_distribuzione_tempi"
    >
      <v-card elevation="0" min-height="300px">
        <v-toolbar
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
        >
          <v-spacer />

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaTipiCausale()"
                class="ml-15"
                large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success" style="font-size: 40px">
                  mdi-floppy
                </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer />

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <!-- chiudi dialog -->
              <v-btn
                @click="chiudiDialogRipartizioneTempi"
                large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error" style="font-size: 40px">
                  mdi-close
                </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <p class="mt-5" style="font-size: 20px">
            Ripartizione Tempi di Fermo {{ minuti_distribuibili_causale }}
          </p>
          <!-- ROW tipi causale -->
          <v-row
            v-for="item in causali_split_tipo.filter(
              (c) => c.id_causale === causale_selezionata.id_causale
            )"
            :key="causali_split_tipo.indexOf(item)"
            justify="center"
          >
            <v-col cols="4">
              <p class="mt-5" style="font-size: 20px">
                {{
                  items_tipi.filter((i) => i.id_tabella == item.tipo).length > 0
                    ? items_tipi.find((i) => i.id_tabella == item.tipo).des
                    : "Ordinario"
                }}
              </p>
            </v-col>
            <v-col cols="4">
              <v-text-field
                background-color="#ffffff"
                dense
                hide-details
                outlined
                @input="calcolaTempoDistribuibile()"
                v-model.number="item.minuti"
                style="
                  border-radius: 0px;
                  display: inline-block;
                  font-size: 20px;
                  line-height: 25px;
                  width: 100px;
                "
                type="number"
                :min="0"
                :max="
                  causale_selezionata.minuti -
                  minuti_distribuiti_causale +
                  item.val_int
                "
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati">
      <v-icon class="ruota" size="100">mdi-cog</v-icon>
      <v-icon class="controruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import TabellaCustomClass from "@/classes/TabellaCustomClass.js";

class Fermo {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "des", default_val: "" },
      { nome: "id_causale", default_val: null },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_causale", default_val: -1 },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "minuti", default_val: 0 },
      { nome: "tipo", default_val: null },
      { nome: "tipo_causale", default_val: "FERMO" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "RegistraTempi",
  components: { SnackbarQV },
  props: {
    id_header_query: { type: Number, default: null },
    visible: { type: Boolean, default: false },
    work_order_sel: { type: Object, default: () => {} },
  },
  data() {
    return {
      // Variabili d'appoggio
      n_minuti_fermo: 0,
      nome_utente: localStorage.getItem("nominativo"),
      // note_tempi: "",
      pezzi_prodotti: null,
      tabella_custom: new TabellaCustomClass(),
      totale_tempi: 0,
      causale_selezionata: new Fermo(),
      minuti_distribuibili_causale: 0,
      minuti_distribuiti_causale: 0,
      minuti_ordinari_totali_distribuiti: 0,
      vincolo_registrazione: 1,

      // Dialog
      dialog_distribuzione_tempi: false,
      // Modal
      caricamento_dati: false,

      // Array
      causali: new Array(),
      causali_split_backup: new Array(),
      // Causali divise per tipo
      causali_split_tipo: new Array(),

      headers_causali: [
        { text: "Causale di tempo", value: "des", sortable: false },
        { text: "Tempo (minuti)", value: "minuti", sortable: false },
        { text: "Dettagli", value: "split", sortable: false },
      ],
      items_tipi: new Array(),
      result_query: new Array(),
      tabella_parametri_query: new Array(),
    };
  },
  watch: {
    visible: {
      immediate: true,
      async handler() {
        if (this.visible === true) {
          this.getCausali();
          await this.getTabelle();
          this.getTabellaDinamica();
        }
      },
    },
  },
  methods: {
    calcolaTotaleTempi() {
      this.totale_tempi = 0;
      this.causali.forEach((elem) => {
        if (elem.tipo == null) {
          this.totale_tempi = this.totale_tempi + parseInt(elem.minuti);
        }
      });
    },
    calcoloFormato(valore_cella, colonna) {
      valore_cella = valore_cella[colonna.value];
      let formato = null;
      try {
        // il campo EXTRA è un json codificato in base64 (con supporto per UTF-8)
        formato = JSON.parse(decodeURIComponent(escape(atob(colonna.formato))));
      } catch (error) {
        console.error(error);
        return undefined;
      }
      let style = null;
      let valore_cella_cast;
      let tipo_dato;
      if (isFinite(Number(valore_cella)) && valore_cella != null) {
        valore_cella_cast = Number(valore_cella);
        tipo_dato = "numero";
      } else if (isFinite(Date.parse(valore_cella)) && valore_cella != null) {
        valore_cella_cast = Date.parse(valore_cella);
        tipo_dato = "data";
      } else {
        if (valore_cella == null) {
          valore_cella_cast = "";
        } else {
          valore_cella_cast = valore_cella.toString();
        }
        tipo_dato = "stringa";
      }
      const operazioni_numeriche = [
        function (item, test) {
          return item < test;
        },
        function (item, test) {
          return item <= test;
        },
        function (item, test) {
          return item == test;
        },
        function (item, test) {
          return item >= test;
        },
        function (item, test) {
          return item > test;
        },
        function (item, test) {
          return item != test;
        },
      ];
      const operazioni_stringa = [
        function () {
          return false;
        },
        function () {
          return false;
        },
        function (item, test, case_sensitive) {
          if (case_sensitive == true) {
            return item == test;
          } else {
            return item.toLowerCase() == test.toLowerCase();
          }
        },
        function () {
          return false;
        },
        function () {
          return false;
        },
        function (item, test, case_sensitive) {
          if (case_sensitive == true) {
            return item != test;
          } else {
            return item.toLowerCase() != test.toLowerCase();
          }
        },
      ];
      formato.forEach((regola) => {
        if (regola.static === true) {
          style = regola.compiled_style;
          return;
        }
        if (regola.range === true) {
          switch (tipo_dato) {
            case "numero":
              if (
                valore_cella_cast >= Number(regola.start_ref) &&
                valore_cella_cast <= Number(regola.end_ref)
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
            case "data":
              if (
                valore_cella_cast >= Date.parse(regola.start_ref) &&
                valore_cella_cast <= Date.parse(regola.end_ref)
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
          }
        } else {
          switch (tipo_dato) {
            case "stringa":
              if (
                operazioni_stringa[Number(regola.operation)](
                  valore_cella_cast,
                  regola.start_ref
                )
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
            case "numero":
              if (
                operazioni_numeriche[Number(regola.operation)](
                  valore_cella_cast,
                  Number(regola.start_ref)
                )
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
            case "data":
              if (
                operazioni_numeriche[Number(regola.operation)](
                  valore_cella_cast,
                  Date.parse(regola.start_ref)
                )
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
          }
        }
      });
      return style;
    },
    clickIndietro() {
      this.causali_split_tipo = [];
      this.$emit("click_indietro");
    },
    clickSalva() {
      this.minuti_ordinari_totali_distribuiti = 0;

      for (let i = 0; i < this.causali.length; i++) {
        let c = this.causali[i];

        let causali_filtrate = this.causali_split_tipo.filter(
          (ct) => ct.id_causale === c.id_causale
        );
        let tempo_causali = 0;
        causali_filtrate.forEach((ct) => {
          tempo_causali += ct.minuti;
          if (ct.tipo === null && ct.minuti > 0 && ct.minuti !== "") {
            this.minuti_ordinari_totali_distribuiti += ct.minuti;
          }
        });
        // se il tempo totale delle causali splittate e 0 e la causale di origine
        // e maggiore di 0 aggiungo il tempo alla causale di tipo ordinario
        if (tempo_causali === 0 && c.minuti > 0) {
          this.causali_split_tipo.find(
            (ct) => ct.tipo == null && ct.id_causale === c.id_causale
          ).minuti = c.minuti;
          tempo_causali = c.minuti;
          this.minuti_ordinari_totali_distribuiti += c.minuti;
        }

        // se sono state create controllo che il tempo totale non sia stato modificato dopo
        // la chiusura del dialog, se e minore del tempo ordinario avverto l'utente dell'errore
        if (tempo_causali != c.minuti) {
          return this.$refs.SnackbarQV.print(
            "orange",
            "Errore distribuzione dei tempi della causale " + c.des
          );
        }
      }
      // Controllo che i minuti distribuiti non superino il massimo
      if (
        this.minuti_ordinari_totali_distribuiti != this.n_minuti_fermo &&
        this.vincolo_registrazione == 1
      ) {
        return this.$refs.SnackbarQV.print(
          "orange",
          `Errore nella distribuzione dei tempi: sono ripartiti ${this.minuti_ordinari_totali_distribuiti} minuti a fronte di ${this.n_minuti_fermo}.`
        );
      }
      const arr_tmp = Array.from(
        this.causali_split_tipo.filter((e) => e.minuti > 0)
      );

      let somma_tempi = 0;
      arr_tmp.forEach((elem) => {
        if (elem.tipo == null) somma_tempi += parseFloat(elem.minuti);
      });

      if (somma_tempi < 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "I tempi di fermo devono corrispondere a una quantità positiva per essere salvati."
        );
        return;
      }
      // Se la query dinamica mi ha dato dei minuti di fermo...
      if (this.n_minuti_fermo != null && this.n_minuti_fermo != "") {
        // Controllo che i minuti rilevati non siano minori di quelli che voglio dichiarare...
        if (
          somma_tempi > parseFloat(this.n_minuti_fermo) &&
          this.vincolo_registrazione == 1
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "I tempi di fermo sono maggiori della quantità rilevata, non è possibile eseguire la registrazione."
          );

          return;
        }

        // Controllo che i minuti rilevati non siano superiori di quelli che voglio dichiarare...
        else if (somma_tempi < parseFloat(this.n_minuti_fermo)) {
          this.$refs.SnackbarQV.print(
            "orange",
            "I tempi di fermo sono minori della quantità rilevata, non è possibile eseguire la registrazione."
          );

          return;
        }
      }
      /* Se non ho dichiarato nessun tempo di fermo,
       * emetto l'evento di chiusura del dialog senza
       * mandare una chiamata, perché non ci sarebbe nulla
       * nella tabella della request e questo non sarebbe
       * conveniente per il BE.*/

      if (arr_tmp.length === 0) {
        this.$emit("click_salva");
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcausalicommessa",
          token: localStorage.user_token,
          tabella: arr_tmp,
        },
      };

      this.caricamento_dati = true;
      //console.log(JSON.stringify(request));
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.$emit("click_salva");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          this.caricamento_dati = false;
          console.error(e);

          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    getCausali() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.user_token,
          tipo: "FASE_causali",
          filter:
            "(val_int IS NULL OR val_int = " +
            this.work_order_sel.id_fase +
            ") AND validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.causali = new Array();
            this.causali_split_tipo = new Array();
            /* Se l'utente non ha mai inserito causali, il BE non mi manda
             * nessuna risposta (neanche un array vuoto). Metto un controllo
             * per gestire la situazione in cui non c'è una risposta dal BE. */
            if (res.data) {
              // Se la risposta c'è, la gestsco.
              res.data.forEach((e) => {
                const causale_tmp = new Fermo();
                causale_tmp.des = e.des;
                causale_tmp.id_causale = e.id_tabella;
                causale_tmp.id_commessa = this.work_order_sel.id_commessa;
                causale_tmp.id_commessa_dettaglio =
                  this.work_order_sel.id_commessa_dettaglio;
                causale_tmp.id_commessa_tempi =
                  this.work_order_sel.id_commessa_tempi;
                causale_tmp.tipo = null;
                this.causali.push(Object.assign({}, causale_tmp));
              });
              this.causali.forEach((c) => {
                let newC = JSON.parse(JSON.stringify(c));
                this.causali_split_tipo.push(newC);
              });
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);

          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getTabellaDinamica() {
      let getstatisticadettaglio = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getstatisticadettaglio",
          token: localStorage.user_token,
          tipologia: "Avanzamento - fermi",
          id_macchina: this.work_order_sel.id_personale,
          id_header: this.id_header_query,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", getstatisticadettaglio)
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              if (res.data.result) {
                if (res.data.result.tabelle_statistiche) {
                  if (res.data.result.tabelle_statistiche.length > 0) {
                    /* Registro la tabella che è stata definita per questo
                     * modulo (dovrebbe essere sempre soltanto una). */
                    this.tabella_custom =
                      res.data.result.tabelle_statistiche[0];
                    console.table(this.tabella_custom.colonne);

                    let performquery = {
                      controller: "Magazzino",
                      method: "POST",
                      richiesta: {
                        action: "performquery",
                        token: localStorage.user_token,
                        id_query: this.tabella_custom.id_query,
                        params: this.tabella_parametri_query,
                        query_string: "",
                      },
                    };

                    this.$store
                      .dispatch("api", performquery)
                      .then((res2) => {
                        if (res2.status === 200) {
                          this.caricamento_dati = false;
                          /* Alcuni valori potrebbero essere periodici.
                           * Per evitare brutti effetti in FE nella stampa
                           * dei valori in tabella vedo quali sono i valori con
                           * una virgola e li formatto. */
                          for (const prop in res2.data.result) {
                            if (parseFloat(res2.data.result[prop]) % 1 > 0) {
                              res2.data.result[prop] = parseFloat(
                                res2.data.result[prop]
                              ).toFixed(2);
                            }
                          }

                          // Registro i dati
                          this.result_query = Array.from(
                            res2.data.result.Table
                          );
                          /* Valorizzo gli input con i valori
                           * che mi arrivano dalla query. */
                          if (this.causali.length > 0) {
                            if (this.result_query.length > 0) {
                              this.n_minuti_fermo =
                                this.result_query[0].n_tempo_1 !== null
                                  ? this.result_query[0].n_tempo_1
                                  : null;
                              console.log(
                                this.result_query[0],
                                this.n_minuti_fermo
                              );
                            }
                          }
                        } else {
                          this.n_minuti_fermo = null;

                          this.caricamento_dati = false;

                          // Stampo una snackbar di avviso.
                          this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                          );
                        }
                      })
                      .catch((err2) => {
                        console.error(err2);

                        this.caricamento_dati = false;
                        if (err2.response.status === 400) {
                          this.$refs.SnackbarQV.print(
                            "error",
                            `${JSON.parse(err2.response.data.message).result}`
                          );
                        } else {
                          this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                          );
                        }
                      });
                  } else {
                    this.n_minuti_fermo = null;

                    this.caricamento_dati = false;
                  }
                }
              }
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.caricamento_dati = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getTabelle() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "'PARAMETRI_QUERY','TIPO_CAUSALE_FERMO'",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            console.log("entrato 0");
            this.tabella_parametri_query = new Array();
            this.items_tipi = new Array();

            if (
              res.data.PARAMETRI_QUERY != null &&
              res.data.PARAMETRI_QUERY != ""
            ) {
              res.data.PARAMETRI_QUERY.forEach((p) => {
                const obj_tmp = {};
                obj_tmp.label = p.cod;
                obj_tmp.value =
                  this.work_order_sel[p.des] != null
                    ? this.work_order_sel[p.des].toString()
                    : "";
                this.tabella_parametri_query.push(Object.assign({}, obj_tmp));
              });
            }
            if (
              res.data.TIPO_CAUSALE_FERMO != null &&
              res.data.TIPO_CAUSALE_FERMO != ""
            ) {
              this.items_tipi =
                res.data.TIPO_CAUSALE_FERMO != null &&
                res.data.TIPO_CAUSALE_FERMO != ""
                  ? res.data.TIPO_CAUSALE_FERMO
                  : new Array();

              // imposto i val_int a 0
              this.items_tipi.forEach((i) => (i.val_int = 0));
            }

            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );

            return false;
          }
        })
        .catch((e) => {
          console.error(e);

          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          return false;
        });
    },
    getVincoloRegistrazione() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
          codice: "VINCOLO_TEMPI_FERMO",
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          if (!res.data.result) {
            return;
          }

          // Se l'array di risposta è vuoto non faccio nulla
          if (!res.data.result.length > 0) {
            return;
          }

          // Se l'array contiene informazioni sulla dichiarazione tempi, le registro.
          if (
            res.data.result.filter((e) => e.codice === "VINCOLO_TEMPI_FERMO")
              .length > 0
          ) {
            this.vincolo_registrazione = res.data.result.filter(
              (e) => e.codice === "VINCOLO_TEMPI_FERMO"
            )[0].val_int;
          }
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      });
    },
    apriDialogDistribuzioneTempi(item) {
      if (item.minuti == 0 || item.minuti < 0) {
        return this.$refs.SnackbarQV.print(
          "error",
          "Inserire tempo prima di fare la distribuzione."
        );
      }
      // salvo la causale selezionata
      this.causale_selezionata = JSON.parse(JSON.stringify(item));
      // funzione che crea un array con le causali divise per tipo, solo se non sono gia state create
      if (
        this.causali_split_tipo.filter(
          (c) => c.id_causale === this.causale_selezionata.id_causale
        ).length <
        this.items_tipi.length + 1
      ) {
        this.creaArrayCausaliTipo();
        // resetto la causale selezionata perche subisce delle variazioni in creaArrayCausaliTipo
        this.causale_selezionata = JSON.parse(JSON.stringify(item));
      }

      // apro il dialog
      this.dialog_distribuzione_tempi = true;
      this.calcolaTempoDistribuibile();

      // Mi faccio un backup delle causali attuali.
      this.causali_split_backup = JSON.parse(
        JSON.stringify(
          this.causali_split_tipo.filter(
            (c) => c.id_causale == this.causale_selezionata.id_causale
          )
        )
      );
    },
    salvaTipiCausale() {
      if (this.minuti_distribuibili_causale != 0) {
        return this.$refs.SnackbarQV.print(
          "orange",
          "Ricontrollare distribuzione tempi di fermo prima di salvare"
        );
      }

      // Chiudo il dialog.
      this.dialog_distribuzione_tempi = false;
    },
    chiudiDialogRipartizioneTempi() {
      this.dialog_distribuzione_tempi = false;

      this.causali_split_tipo
        .filter((c) => c.id_causale === this.causale_selezionata.id_causale)
        .forEach((c) => {
          /* Se ha una corrispondenza nell'array di backup, riporto
           * i minuti alla quantità segnata dal backup. */
          if (
            this.causalli_split_backup.filter(
              (b) => b.id_tipo == c.id_tipo && b.id_causale == c.id_causale
            ).length > 0
          ) {
            c.minuti = this.causalli_split_backup.filter(
              (b) => b.id_tipo == c.id_tipo && b.id_causale == c.id_causale
            )[0].minuti;
          }
        });
    },
    creaArrayCausaliTipo() {
      // creo una causale per ogni tipo
      this.items_tipi.forEach((i) => {
        this.causale_selezionata = JSON.parse(
          JSON.stringify(this.causale_selezionata)
        );
        this.causale_selezionata.minuti = 0;
        this.causale_selezionata.tipo = i.id_tabella;
        // se non esiste gia la inserisco nell'array
        if (
          this.causali_split_tipo.filter(
            (c) =>
              c.tipo == this.causale_selezionata.tipo &&
              c.id_causale == this.causale_selezionata.id_causale
          ).length === 0
        ) {
          this.causali_split_tipo.push(this.causale_selezionata);
        }
      });
    },
    calcolaTempoDistribuibile() {
      this.minuti_distribuiti_causale = 0;
      this.minuti_ordinari_totali_distribuiti = 0;

      this.causali_split_tipo
        .filter((c) => c.id_causale === this.causale_selezionata.id_causale)
        .forEach((c) => (this.minuti_distribuiti_causale += c.minuti));

      this.minuti_distribuibili_causale =
        this.causale_selezionata.minuti - this.minuti_distribuiti_causale;

      this.causali_split_tipo
        .filter((c) => c.tipo === null)
        .forEach((c) => (this.minuti_ordinari_totali_distribuiti += c.minuti));
    },
    printConfermaPezzi() {
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione dei dati avvenuta con successo!"
      );
    },
  },
  mounted() {
    this.getVincoloRegistrazione();
  },
};
</script>

<style scoped>
@keyframes controtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes rotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.controruota {
  animation: controtazione 1s infinite;
  animation-timing-function: linear;
}
.ruota {
  animation: rotazione 1s infinite;
  animation-timing-function: linear;
}
</style>
